import React from 'react';
import ModalRollback from "@UIComponents/Modal/ModalRollback";
import {useFormikContext} from "formik";
import submitData from "@inappPages/InappsPage/methods/submitData";
import useInappStatus from "@hooks/useInappStatus";
import {CONTENT_EDITOR_ROLE, GAME_QA_ROLE} from "@constants/ENV";
import {hasGroup} from "@utils/helpers/access";

const RollbackButtons = () => {
    const status = useInappStatus();
    const {values} = useFormikContext()
    const isContentEditor = hasGroup(CONTENT_EDITOR_ROLE);
    const isGameQa = hasGroup(GAME_QA_ROLE);

    if (status === 'Ready' && isGameQa) {
        return <ModalRollback
            methodName={'rollbackPurchase'}
            submitData={submitData}
            modalText={'Are you sure you want to Roll back to “On review”?'}
            btnText={'Roll back to “On review”'}
            confirmBtnText={'Yes, roll back'}
            variant="outline-primary"
        />
    } else if (status === 'OnReview' && values.hasActivePurchase && isContentEditor) {
        return <ModalRollback
            methodName={'deletePurchase'}
            submitData={submitData}
            modalText={'Are you sure you want to roll back to “Active”?'}
            description={'Confirming "Yes, roll back" will remove all changes you made previously and the in-app will return to Active status.'}
            btnText={'Roll back to “Active”'}
            confirmBtnText={'Yes, roll back'}
        />
    }
};

export default RollbackButtons;
